<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <router-view v-if="!support.mode || support.active || $route.name === 'student-support'" @setAppClasses="setAppClasses" />
    <section v-else class="support-ended" aria-labelledby="support-ended-title">
      <div class="support-ended__card">
        <div class="support-ended__icon" aria-hidden="true">
          <feather-icon icon="LockIcon" svgClasses="w-6 h-6" />
        </div>
        <p class="support-ended__eyebrow">STUDENT WEB · โหมดผู้ดูแล</p>
        <h1 id="support-ended-title">โหมดผู้ดูแลสิ้นสุดแล้ว</h1>
        <p class="support-ended__reason" role="status">{{ supportEndReason }}</p>
        <p class="support-ended__instruction">หากต้องการดูข้อมูลต่อ กรุณากลับไปที่หน้าผู้ดูแล<br class="support-ended__desktop-break" /> แล้วเปิด Student Web อีกครั้ง</p>
        <button type="button" class="support-ended__close" @click="closeSupportTab">ปิดแท็บนี้</button>
        <p v-if="supportCloseAttempted" class="support-ended__hint" role="status">หากแท็บยังไม่ปิด สามารถกดปุ่ม × บนแท็บของเบราว์เซอร์ได้</p>
        <div class="support-ended__footer">การเข้าสู่ระบบในแท็บอื่นไม่ได้รับผลกระทบ</div>
      </div>
    </section>
  </div>
</template>

<script>
// import Swal from 'sweetalert2'
import themeConfig from '@/../themeConfig.js'
import { supportState, onSupportEnd } from '@/utils/student-support-session'
import { apolloClient } from '@/setup/apollo-setup'

export default {
  computed: {
    support () { return supportState },
    supportEndReason () {
      const message = this.support.message || ''
      if (message.startsWith('ออกจากโหมดผู้ดูแล')) return 'คุณออกจากโหมดดูข้อมูลนักศึกษาเรียบร้อยแล้ว'
      if (message.startsWith('สิทธิ์หมดอายุ')) return 'สิทธิ์ดูข้อมูลชั่วคราวหมดอายุแล้ว'
      if (message.startsWith('สิทธิ์ไม่พร้อมใช้งาน')) return 'สิทธิ์ดูข้อมูลนี้ไม่พร้อมใช้งานแล้ว'
      return 'การดูข้อมูลในแท็บนี้สิ้นสุดแล้ว'
    }
  },
  data () {
    return {
      vueAppClasses: [],
      supportCloseAttempted: false
    }
  },
  watch: {
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    }
  },
  methods: {
    closeSupportTab () {
      // Script-opened support windows can close themselves; otherwise keep the manual-close hint visible.
      this.supportCloseAttempted = true
      window.close()
    },
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  mounted () {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  },
  async created () {
    const vm = this
    const dir = vm.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', vm.handleWindowResize)
    window.addEventListener('scroll', vm.handleScroll)

    // Support is an isolated, memory-only session: do not restore or alter a student's normal login.
    if (supportState.mode) {
      this.removeSupportEnd = onSupportEnd(() => {
        this.$store.commit('setLogoutStatus')
        this.$store.commit('Accounting/clearSupportData')
        apolloClient.clearStore().catch(() => {})
      })
    } else {
      await vm.$store.dispatch('initUser', {vm: vm})
    }

    // if(vm.$store.state.currentUser !== true){
    //   const { value: email } = await Swal.fire({
    //     title: 'Input email address',
    //     input: 'email',
    //     inputLabel: 'Your email address',
    //     inputPlaceholder: 'Enter your email address',
    //     allowOutsideClick: false
    //   })
    //   if (email) {
    //     Swal.fire(`Entered email: ${email}`)
    //   }
    // }

    // await this.$store.dispatch('initializeData', {vm: this})
  },
  destroyed () {
    if (this.removeSupportEnd) this.removeSupportEnd()
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

</script>

<style scoped>
.support-ended {
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  box-sizing: border-box;
  background: #f5f7fa;
  color: #273548;
}
.support-ended__card {
  width: 100%;
  max-width: 500px;
  padding: 40px 36px 28px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #e7ebf0;
  border-radius: 18px;
  box-shadow: 0 12px 40px rgba(28, 46, 68, .06);
  text-align: center;
}
.support-ended__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 24px;
  border-radius: 50%;
  background: #eef3f8;
  color: #49647e;
}
.support-ended__eyebrow { margin-bottom: 12px; color: #6b7888; font-size: 11px; letter-spacing: .07em; }
.support-ended h1 { margin: 0 0 14px; color: #273548; font-size: 26px; font-weight: 600; line-height: 1.5; }
.support-ended__reason { color: #526174; line-height: 1.7; }
.support-ended__instruction { margin-top: 18px; color: #6b7888; font-size: 13px; line-height: 1.9; }
.support-ended__close {
  margin-top: 28px;
  min-height: 44px;
  min-width: 160px;
  padding: 10px 24px;
  border: 1px solid #d7dfe8;
  border-radius: 8px;
  background: #f8fafc;
  color: #344c64;
  font: inherit;
  font-weight: 500;
  cursor: pointer;
}
.support-ended__close:hover { background: #edf2f7; }
.support-ended__close:focus-visible { outline: 2px solid #49647e; outline-offset: 3px; }
.support-ended__hint { margin-top: 14px; color: #6b7888; font-size: 12px; line-height: 1.7; }
.support-ended__footer { margin-top: 28px; padding-top: 20px; border-top: 1px solid #edf0f4; color: #6b7888; font-size: 12px; line-height: 1.7; }
@media (max-width: 480px) {
  .support-ended { padding: 20px 16px; }
  .support-ended__card { padding: 32px 20px 24px; border-radius: 14px; }
  .support-ended h1 { font-size: 23px; }
  .support-ended__close { width: 100%; }
  .support-ended__desktop-break { display: none; }
}
</style>
